import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Textarea } from "@/components/ui/textarea";
import { PRODUCT_TYPES } from "@/lib/api";

const Field = ({ label, children }) => (
  <div>
    <Label>{label}</Label>
    <div className="mt-2">{children}</div>
  </div>
);

export const DetailsForm = ({ p, set, cats }) => (
  <div className="bg-[#FFFDF9] border border-[#2A2325]/10 p-6 space-y-5" data-testid="details-form">
    <div className="eyebrow">Front cover</div>
    <Field label="Title"><Input value={p.title} onChange={(e) => set({ title: e.target.value })} className="bg-white" data-testid="details-title-input" /></Field>
    <Field label="Subtitle"><Input value={p.subtitle} onChange={(e) => set({ subtitle: e.target.value })} className="bg-white" data-testid="details-subtitle-input" /></Field>
    <div className="grid sm:grid-cols-2 gap-4">
      <Field label="Series line (top of cover)"><Input value={p.series} onChange={(e) => set({ series: e.target.value })} placeholder="An Enthusiast's Looking Guide" className="bg-white" data-testid="details-series-input" /></Field>
      <Field label="Category">
        <Select value={p.category_id} onValueChange={(v) => set({ category_id: v })}>
          <SelectTrigger className="bg-white" data-testid="details-category-select"><SelectValue /></SelectTrigger>
          <SelectContent>{cats.map((c) => <SelectItem key={c.id} value={c.id}>{c.name}</SelectItem>)}</SelectContent>
        </Select>
      </Field>
      <Field label="Product type">
        <Select value={p.product_type} onValueChange={(v) => set({ product_type: v })}>
          <SelectTrigger className="bg-white" data-testid="details-type-select"><SelectValue /></SelectTrigger>
          <SelectContent>{PRODUCT_TYPES.map((t) => <SelectItem key={t.value} value={t.value}>{t.label}</SelectItem>)}</SelectContent>
        </Select>
      </Field>
    </div>
    <div className="eyebrow pt-4 border-t border-[#2A2325]/10">Back cover (your logo is added automatically)</div>
    <Field label="Back cover headline"><Input value={p.back_headline} onChange={(e) => set({ back_headline: e.target.value })} placeholder="They told him it could not be built" className="bg-white" data-testid="details-back-headline-input" /></Field>
    <Field label="Back cover text (one paragraph per line)"><Textarea rows={5} value={p.back_blurb} onChange={(e) => set({ back_blurb: e.target.value })} className="bg-white font-body-serif" data-testid="details-back-blurb-input" /></Field>
  </div>
);
